const GLOBAL_MEDIA_QUERIES = {
  tab: '(max-width: 1280px)',
};

export default GLOBAL_MEDIA_QUERIES;
